import { render, staticRenderFns } from "./vehicleEvents.vue?vue&type=template&id=2059b61c&"
import script from "./vehicleEvents.vue.js?vue&type=script&lang=js&"
export * from "./vehicleEvents.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports